import { useRef, useEffect } from 'react'
import { useLang } from '../utils/hooks'
import { langSessions } from '../assets/langSessions'

const SessionModify = ({
  session,
  okSession,
  handleCancelModify,
  handleSessionChange,
  handleActualize,
  disabledDemo,
}) => {
  const { lang } = useLang()
  const firstField = useRef(null)
  const choosenLang = lang === 'eng' ? langSessions.eng : langSessions.fr

  useEffect(() => {
    if (!firstField.current) return
    firstField.current.focus()
  }, [firstField])
  return (
    <div
      className="box has-background-warning-light"
      style={{ marginTop: '200px' }}
    >
      <h1 className="subtitle is-5">{choosenLang.modalHead}</h1>
      <div className="field is-horizontal">
        <div className="field-label ">
          <label className="label">{choosenLang.modalTitle}</label>
        </div>
        <div className="field-body">
          <div className="field">
            <div className="control has-icons-right">
              <input
                id="title"
                ref={firstField}
                className={
                  'input ' + (okSession.titleOk ? 'is-success' : 'is-danger')
                }
                type="text"
                value={session.sessionTitle}
                onChange={(e) => handleSessionChange(e)}
                placeholder={choosenLang.modalTitle}
              />
              <span className="icon is-small is-right">
                <i
                  className={
                    'fa ' +
                    (okSession.titleOk ? 'fa-check' : 'fa-exclamation-triangle')
                  }
                ></i>
              </span>
              {!okSession.titleOk && (
                <p className="help is-danger">{choosenLang.minTitleNbChar}</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="field is-horizontal">
        <div className="field-label">
          <label className="label">{choosenLang.modalComments}</label>
        </div>
        <div className="field-body">
          <div className="field">
            <div className="control">
              <input
                id="comments"
                className="input is-success"
                type="text"
                value={session.sessionComments}
                onChange={(e) => handleSessionChange(e)}
                placeholder={choosenLang.modalComments}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="field is-grouped">
        <div className="control">
          <button
            className="button is-link"
            disabled={!okSession.titleOk || disabledDemo}
            onClick={handleActualize}
            title={disabledDemo ? choosenLang.registeredOnly : ''}
          >
            {choosenLang.modalSave}
          </button>
        </div>
        <div className="control">
          <button
            className="button is-link is-light"
            onClick={handleCancelModify}
          >
            {choosenLang.modalCancel}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SessionModify
